import React from 'react';
import { Grid } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import SnackbarHandler, { useSnackbar } from './components/snackbar/Snackbar';
import IDCGTheme from "./themes/IDCGTheme";
import Home from './components/home/Home';
import "./App.css";

const App = ({ getCurrentUser, getAccessToken, theme: OneProfileTheme }) => {

  const { REACT_APP_THEME } = JSON.parse(process.env.REACT_APP_IDCG_ENV)["frontend"];
  const { handleSnackbar, createSnackbar } = useSnackbar();

  let THEME = IDCGTheme;

  if (REACT_APP_THEME === "OneProfileTheme") {
    THEME = OneProfileTheme;
  }

  return (
    <div className="app">
      <ThemeProvider theme={THEME}>
        <Grid container>
          <SnackbarHandler handleSnackbar={handleSnackbar}>
            <Home getUser={getCurrentUser} getAccessToken={getAccessToken} createSnackbar={createSnackbar} />
          </SnackbarHandler>
        </Grid>
      </ThemeProvider>
    </div>
  );
}

export default App;
